import axios from 'axios'

const service = axios.create()
const host = 'https://lzc.api.bjadks.com'

axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
axios.interceptors.response.use(
  response => {
    const {
      data
    } = response
    return data
  },
  error => {
    console.error(error)
    return Promise.reject({
      code: 9001,
      message: '数据请求失败，请稍后重试~'
    })
  }
)

service.get = function(path, params) {
  return axios({
    method: 'get',
    url: host + path,
    params: params,
    timeout: 30000
  })
}

service.post = function(path, params) {
  return axios({
    method: 'post',
    url: host + path,
    params: params,
    timeout: 30000
  })
}

service.postdata = function(path, params) {
  return axios({
    method: 'post',
    url: host + path,
    data: params,
    timeout: 30000
  })
}

service.postDataWithHeader = function(path, params, header) {
  return axios({
    method: 'post',
    url: host + path,
    data: params,
    headers: header,
    timeout: 30000
  })
}
service.upload = function(path, params, header) {
  return axios({
    method: 'post',
    baseURL: host,
    url: path,
    headers: header,
    timeout: 30000,
    data: params.formatData,
    responseType: 'json',
    processData: false,
    contentType: false
  })
}

export default service
